import { render, staticRenderFns } from "./payments.vue?vue&type=template&id=d152c63c&scoped=true&"
import script from "./payments.vue?vue&type=script&lang=js&"
export * from "./payments.vue?vue&type=script&lang=js&"
import style1 from "./payments.vue?vue&type=style&index=1&id=d152c63c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d152c63c",
  null
  
)

export default component.exports